import fromAnyToString from 'utils/converters/fromAnyToString';

const toUserId = (salonId, stylistId, userId) => {
  if (stylistId) return `${salonId}_${stylistId}`;
  if (userId) return `${salonId}_${userId}`;
  return null;
};

const buildPersonalPayload = (salonId, stylistId, userId) => {
  if (!salonId || !stylistId) return null;
  return { customerId: salonId, userId: `${salonId}_${stylistId}` };
};

const buildBusinessPayload = (salonId, stylistId, userId) => {
  if (!salonId) return null;
  const uid = toUserId(salonId, stylistId, userId);
  if (!uid) return null;
  return { customerId: salonId, userId: uid };
};

/**
 * Returns an ordered array of capital-session request payloads to try.
 *
 * Priority rules:
 *  - Personal offer always takes priority over business offer.
 *  - Receptionists can only see personal offers (never business).
 *  - Managers without a personal offer fall back to the business offer.
 *
 * userId is always included for DaySmart's server-side dismissal and snooze
 * tracking.  Format is salonId_stylistId when a stylistId is available,
 * otherwise salonId_userId from the logged-in user.
 *
 * merchantId (Stripe Account ID) is NOT included here — it is passed
 * client-side as options.thirdPartyMerchantId to the SDK component.
 *
 * @param {{ salonId: string|null, stylistId: string|null, userId: string|null, isManager: boolean, isReceptionist: boolean }}
 * @returns {object[]}  Payloads in priority order (first success wins).
 */
const buildCapitalSessionPayloads = ({ salonId, stylistId, userId, isManager, isReceptionist }) => {
  const id = fromAnyToString(salonId) || null;
  if (!id) return [];

  const payloads = [];

  const personal = buildPersonalPayload(id, stylistId, userId);
  if (personal) {
    payloads.push(personal);
  }

  if (isManager && !isReceptionist) {
    const business = buildBusinessPayload(id, stylistId, userId);
    if (business) {
      payloads.push(business);
    }
  }

  return payloads;
};

export default buildCapitalSessionPayloads;
